import React from 'react';
import { ClasseDefWithUser } from 'types/classe/classe.def';
import { GoToPage } from 'helpers/page/goToPage';
import pages from 'routes/pages';
import { MY_ID } from 'helpers/user/authorization';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';
import { getShopUrl } from '../../../../../domain/shop';

export interface TableMyResultContentProps {
  classe: ClasseDefWithUser;
  toPage: GoToPage;
}

export const MobileTabLineInformations = ({
  classe,
  toPage
}: TableMyResultContentProps) => {
  const toElevePage = toPage(pages.ELEVE_ACCOUNT_PAGE.path);
  const toSettingsPage = toPage(pages.MY_ACCOUNT.path);

  return (
    <>
      {classe?.users?.map(user => (
        <FeatureContainer key={user.id} padding="mobileTab">
          <MobileTabLineBox
            texts={[
              { text: user?.lastname, style: 'bold' },
              { text: user?.firstname, style: 'bold' },
              { text: user.username },
              { text: user.email },
              {
                text: user.shop && classe.id && getShopUrl(user.shop, classe.id)
              }
            ]}
          />
          <MobileTabLineBox
            title="Mot de passe"
            texts={[{ text: user.mdp, style: 'bold' }]}
          />
          <ButtonWithText
            variant="mobileTab"
            onClick={
              user.id === MY_ID
                ? toSettingsPage
                : () => toElevePage({ id: user.id || MY_ID })
            }
            icon={'Edit'}
            content="Modifier"
          />
        </FeatureContainer>
      ))}
    </>
  );
};
